import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import HeaderTitle from '../HeaderTitle';
import { Form, Label, Input, Button } from '../Form';
import Errors from '../Errors';
import { api, setToken } from '../../utils/api';
import withTranslations from '../../utils/translations/withTranslations';

import '../PasswordForgot/PasswordForgot.css';

class PasswordReset extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: false,
      isBusy: false
    };
  }

  submit(data) {
    const { history } = this.props;
    this.setState({ isBusy: true });

    api
      .post('/auth/password/reset', data)
      .then(({ data }) => {
        // Store the token in localStorage
        setToken(data.access_token);

        // Go to /
        history.push('/');
      })
      .catch(({ data: errors }) => this.setState({ isBusy: false, errors }));
  }

  render() {
    const { isValid, errors, isBusy } = this.state;
    const { match, translate } = this.props;

    return (
      <div className="PasswordForgot">
        <div className="PasswordForgot__Header">
          <HeaderTitle />
        </div>
        <div className="PasswordForgot__Content">
          <h1>{translate('password_reset.title')}</h1>

          <Form
            ref={form => (this.form = form)}
            onValidationChange={valid => this.setState({ isValid: valid })}
            onSubmit={data => this.submit(data)}
          >
            <Errors errors={errors} />
            <Label text={translate('password_reset.email')} />
            <Input rules={['required', 'email']} name="email" />
            <Label text={translate('password_reset.password')} />
            <Input rules={['required']} name="password" type="password" />
            <Input name="token" type="hidden" value={match.params.token} />

            <Button
              solid
              className="Form__Button"
              disabled={!isValid || isBusy}
            >
              {translate('password_reset.submit')}
            </Button>
          </Form>
        </div>
      </div>
    );
  }
}

export default withRouter(withTranslations(PasswordReset));
